import React from "react";
import { TableRow, TableCell, Checkbox } from "@material-ui/core"
import MoreHorizIcon from "@material-ui/icons/MoreHoriz";

export const SchoolRow = ({
  isItemSelected,
  row,
  openActionMenu,
  actionButtonClass,
  handleClick,
  selectionKey,
  labelId,
}) => {
  return (
    <TableRow
      className={"school_row"}
      hover
      style={{ padding: "3px 0px", borderBottom: '1px solid lightgray' }}
      role="checkbox"
      aria-checked={isItemSelected}
      tabIndex={-1}
      key={row.name}
      selected={isItemSelected}
    >
      <TableCell padding="checkbox">
        <Checkbox
          onClick={(event) => handleClick(event, row[selectionKey])}
          checked={isItemSelected}
          inputProps={{ "aria-labelledby": labelId }}
        />
      </TableCell>
      <TableCell align="center" style={{ fontWeight: 500 }}>{row["id"]}</TableCell>
      <TableCell align="center" style={{ fontWeight: 500 }}>{row["merchantId"]}</TableCell>
      <TableCell align="center" style={{ fontWeight: 500 }}>{row["payeeType"]}</TableCell>
      <TableCell align="center" style={{ textTransform: "capitalize", fontWeight: 500 }}>
        {row["name"]}
      </TableCell>
      <TableCell align="center" style={{ fontWeight: 500 }}>{row["vat"]}</TableCell>
      <TableCell align="center" style={{ fontWeight: 500 }}>{row["paynestFee"]}</TableCell>
      <TableCell align="center">
        <div
          role="presentation"
          onClick={(e) => {
            openActionMenu(e, row);
          }}
          className={actionButtonClass}
        >
          <MoreHorizIcon />
        </div>
      </TableCell>
    </TableRow>
  );
};
